/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import './PreferencesCheckwritingTable.scss';

import { bool } from 'prop-types';
import capitalize from 'lodash/capitalize';
import isEmpty from 'lodash/isEmpty';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import AccountDisplay from 'components/shared/AccountDisplay/AccountDisplay';
import MobileAccountDisplay from 'components/shared/AccountDisplay/MobileAccountDisplay';
import { getCheckwritingAccountGroups } from 'state/account/AccountSelectors';
import { ReactComponent as Disabled } from 'assets/icons/disabled.svg';
import { ReactComponent as Enabled } from 'assets/icons/enabled.svg';

const ENABLED = 'enabled';
const DISABLED = 'disabled';
const CHECKWRITING_TYPES = [ENABLED, DISABLED];

const AccountGroupTableRow = ({ account, isMobile, type }) => (
  <tr>
    <td className={`body-cell is-${type}`} colSpan={isMobile ? 2 : 1}>
      {isMobile ? (
        <MobileAccountDisplay account={account} />
      ) : (
        <AccountDisplay account={account} withType={true} />
      )}
    </td>
    {!isMobile && (
      <td className="preferences-checkwriting-table-icon-container body-cell">
        <div className="preferences-checkwriting-table-icon">
          {type === ENABLED ? (
            <Fragment>
              <Enabled />
              <span>Yes</span>
            </Fragment>
          ) : (
            <Fragment>
              <Disabled />
              <span>No</span>
            </Fragment>
          )}
        </div>
      </td>
    )}
  </tr>
);

const AccountGroupTable = ({ accounts, isMobile, type }) => (
  <table className="preferences-checkwriting-table">
    <thead className="preferences-checkwriting-table-header">
      <tr>
        <th className={`header-cell is-${type}`} colSpan={2}>
          {capitalize(type)}
        </th>
      </tr>
    </thead>
    <tbody className="preferences-checkwriting-table-body">
      {isEmpty(accounts) ? (
        <tr>
          <td className="body-cell" colSpan={2}>
            No accounts have checkwriting {type}.
          </td>
        </tr>
      ) : (
        accounts.map((account, key) => (
          <AccountGroupTableRow
            account={account}
            isMobile={isMobile}
            key={key}
            type={type}
          />
        ))
      )}
    </tbody>
  </table>
);

const PreferencesCheckwritingTable = ({
  checkWritingAccountGroups,
  isMobile
}) => (
  <div className="preferences-checkwriting-table-page">
    <div className="preferences-checkwriting-table-page-header">
      <span>Account Name</span>
      <span>Checkwriting Enabled</span>
    </div>
    <div className="preferences-checkwriting-table-container">
      {CHECKWRITING_TYPES.map((type, key) => (
        <AccountGroupTable
          accounts={checkWritingAccountGroups[type]}
          isMobile={isMobile}
          key={key}
          type={type}
        />
      ))}
    </div>
  </div>
);

PreferencesCheckwritingTable.propTypes = {
  isMobile: bool
};

PreferencesCheckwritingTable.defaultProps = {
  isMobile: false
};

const mapStateToProps = (state) => ({
  checkWritingAccountGroups: getCheckwritingAccountGroups(state)
});

export default connect(mapStateToProps)(PreferencesCheckwritingTable);
